import { css } from "styled-system/css";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FadeIn } from "@/components/ui/animated";

export function ConfirmEmailChangePage() {
  const [sp] = useSearchParams();
  const token = sp.get("token") ?? "";
  const [status, setStatus] = useState<"idle" | "loading" | "ok" | "err">("idle");
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!token.trim()) {
      setStatus("err");
      setMsg("Enlace inválido.");
      return;
    }
    let cancelled = false;
    void (async () => {
      setStatus("loading");
      const r = await fetch("/api/auth/confirm-email-change", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token.trim() }),
      });
      const j = (await r.json().catch(() => ({}))) as { error?: string };
      if (cancelled) return;
      if (r.ok) {
        setStatus("ok");
        setMsg("Tu correo fue actualizado. Volvé a iniciar sesión con el nuevo email.");
      } else {
        setStatus("err");
        setMsg(j.error ?? "No se pudo confirmar el cambio.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <main className={css({ minH: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bg: "#f4f6f8", p: "6" })}>
      <FadeIn>
        <div
          className={css({
            w: "100%",
            maxW: "420px",
            bg: "white",
            rounded: "xl",
            borderWidth: "1px",
            borderColor: "#e2e8f0",
            p: "8",
            textAlign: "center",
          })}
        >
          <h1 className={css({ fontSize: "xl", fontWeight: "bold", color: "#0f172a", mb: "3" })}>Confirmar correo</h1>
          {status === "loading" ? (
            <p className={css({ fontSize: "sm", color: "#64748b" })}>Confirmando…</p>
          ) : (
            <p
              className={css({
                fontSize: "sm",
                lineHeight: "1.5",
                color: status === "ok" ? "#166534" : "#b91c1c",
              })}
            >
              {msg}
            </p>
          )}
          <p className={css({ mt: "6", fontSize: "sm" })}>
            <Link to="/auth/login" className={css({ color: "#4f46e5", fontWeight: "semibold" })}>
              Iniciar sesión
            </Link>
          </p>
        </div>
      </FadeIn>
    </main>
  );
}
